import React, { useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Switch, Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { Select } from '../form-fields/Select';
import ColorPicker from '../../puck/reusable-props/ColorPicker';
import Toggle from '../../../components/common/toggleButton';

interface CustomIconProps {
  value: ICustomIconValueProps;
  onChange: (_value: ICustomIconValueProps) => void;
  title: string;
}

export interface ICustomIconValueProps {
  deviceType: string;
  icon: {
    [key: string]: boolean;
    mobile: boolean;
    tablet: boolean;
    desktop: boolean;
  };
  size: {
    [key: string]: string;
    mobile: string;
    tablet: string;
    desktop: string;
  };
  iconColor: {
    [key: string]: string;
    mobile: string;
    tablet: string;
    desktop: string;
  };
}
const paddingOption = [
  { label: '0', value: '0px' },
  { label: '1px', value: '1px' },
  { label: '2px', value: '2px' },
  { label: '3px', value: '3px' },
  { label: '4px', value: '4px' },
  { label: '5px', value: '5px' },
  { label: '6px', value: '6px' },
  { label: '7px', value: '7px' },
  { label: '8px', value: '8px' },
  { label: '9px', value: '9px' },
  { label: '10px', value: '10px' },
  { label: '11px', value: '11px' },
  { label: '12px', value: '12px' },
  { label: '13px', value: '13px' },
  { label: '14px', value: '14px' },
  { label: '15px', value: '15px' },
  { label: '16px', value: '16px' },
  { label: '17px', value: '17px' },
  { label: '18px', value: '18px' },
  { label: '19px', value: '19px' },
  { label: '20px', value: '20px' },
  //   { label: '21px', value: '21px' },
  //   { label: '22px', value: '22px' },
  //   { label: '23px', value: '23px' },
  //   { label: '24px', value: '24px' },
  //   { label: '25px', value: '25px' },
  //   { label: '26px', value: '26px' },
  //   { label: '27px', value: '27px' },
  //   { label: '28px', value: '28px' },
  //   { label: '29px', value: '29px' },
  //   { label: '30px', value: '30px' },
  //   { label: '31px', value: '31px' },
  //   { label: '32px', value: '32px' },
  //   { label: '33px', value: '33px' },
  //   { label: '34px', value: '34px' },
  //   { label: '35px', value: '35px' },
  //   { label: '36px', value: '36px' },
  //   { label: '37px', value: '37px' },
  //   { label: '38px', value: '38px' },
  //   { label: '39px', value: '39px' },
  //   { label: '40px', value: '40px' },
  //   { label: '41px', value: '41px' },
  //   { label: '42px', value: '42px' },
  //   { label: '43px', value: '43px' },
  //   { label: '44px', value: '44px' },
];

const CustomizeIcon: React.FC<CustomIconProps> = ({
  title,
  value,
  onChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div>
      <div
        className="flex justify-between font-bold cursor-pointer py-2 bg-slate-100 rounded-md pagebuilder-theme"
        onClick={() => setIsOpen(!isOpen)}>
        <h3>{title}</h3>
        {!isOpen ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
      </div>
      {isOpen && (
        <div className="flex flex-col gap-4 mt-3 border border-gray-300 rounded p-2 w-full">
          <Toggle<ICustomIconValueProps>
            value={value}
            onChange={newValue => onChange({ ...value, ...newValue })}
            heading={{ label: 'Device', value: 'device' }}
            options={[
              { label: 'Desktop', value: 'desktop' },
              { label: 'Tablet', value: 'tablet' },
              { label: 'Mobile', value: 'mobile' },
            ]}
            propName="deviceType"
          />
          <div className="flex justify-between items-center mb-3">
            <p className="text-sm font-semibold">Hide Icon</p>
            <div className="flex gap-0.5 items-center">
              <Tooltip
                title={'Toggle this switch to hide Icon'}
                placement="top-start">
                <InfoIcon fontSize="small" className="h-1 w-1" />
              </Tooltip>
              <Switch
                onChange={e => {
                  onChange({
                    ...value,
                    icon: {
                      ...value?.icon,
                      [value?.deviceType]: e.target.checked,
                    },
                  });
                }}
                checked={value?.icon?.[value?.deviceType]}
                inputProps={{ 'aria-label': 'controlled' }}
              />
            </div>
          </div>
          <div className="flex justify-between items-center mb-3">
            <p className="text-sm font-semibold">Size</p>
            <div className="flex gap-0.5 items-center">
              <Tooltip
                title={
                  'By adjusting the pixels, we control the height of the Timer component, shaping its appearance on the screen.'
                }
                placement="top-start">
                <InfoIcon fontSize="small" className="h-1 w-1" />
              </Tooltip>
              <Select
                labelColor="text-white"
                value={value?.size?.[value?.deviceType]}
                onChange={e => {
                  onChange({
                    ...value,
                    size: {
                      ...value?.size,
                      [value?.deviceType]: e.target.value,
                    },
                  });
                }}
                className="flex justify-between items-center mb-3"
                options={paddingOption}
              />
            </div>
          </div>

          <ColorPicker
            value={value?.iconColor?.[value?.deviceType]}
            label="Icon Color"
            onChange={color =>
              onChange({
                ...value,
                iconColor: {
                  ...value?.iconColor,
                  [value?.deviceType]: color,
                },
              })
            }
            tooltip={'Icon Color'}
          />
        </div>
      )}
    </div>
  );
};

export default CustomizeIcon;
